<template>
  <v-card class="initiation input-card">
    <div class="tab-bar">
    <v-tabs
      color="accent"
      v-model="tab"
      grow
      show-arrows
    >
      <v-tabs-slider></v-tabs-slider>
      <v-tab href="#details">Details</v-tab>
      <v-tab href="#documents" :disabled="disabled" >Documents</v-tab>
    </v-tabs>
    </div>
    <v-tabs-items v-model="tab">
      <v-tab-item value="details">
        <v-container class="input-wrapper">
          <v-row>
            <v-col class="spacing-col" cols="2"></v-col>
            <v-col xs="12" sm="12" md="8" lg="8" xl="8" cols="12">
              <initiation-details :isSaved="initiationSaved" ref="details"></initiation-details>
            </v-col>
            <v-col class="spacing-col" cols="2"></v-col>
          </v-row>
        </v-container>
      </v-tab-item>
      <v-tab-item value="documents">
        <v-container class="input-wrapper">
          <v-row>
            <v-col class="spacing-col" cols="2"></v-col>
            <v-col class="document-uploader-wrapper" xs="12" sm="12" md="8" lg="8" xl="8" cols="12">
              <file-upload uploadType="document" ref="saveDocs" step="Initiation"></file-upload>
            </v-col>
            <v-col class="spacing-col" cols="2"></v-col>
          </v-row>
        </v-container>
      </v-tab-item>
    </v-tabs-items>
    <div v-if="this.userRole !== 'Sub Foreman'" class="footer">
      <v-container pa-0>
        <v-row>
          <v-col class="spacing-col" cols="2"></v-col>
          <v-col xs="12" sm="12" md="8" lg="8" xl="8" cols="12" class="btn-wrapper">

            <div v-if=" task !== null && task.status !== 'Initiation'">
              <v-tooltip bottom color="secondary">
                <template v-slot:activator="{ on }">
                  <v-btn depressed color="accent" class="btn-reset" @click="reset" v-on="on">
                    Reset
                    <v-icon dark right>mdi-history</v-icon>
                  </v-btn>
                </template>
                <span>Reset to this step (Initiation)</span>
              </v-tooltip>
            </div>
            <div v-else>
              <v-tooltip bottom color="secondary">
                <template v-slot:activator="{ on }">
                  <v-btn depressed color="accent" class="btn-complete" @click="complete" :disabled="disabled" v-on="on">
                    Complete
                    <v-icon dark right>mdi-checkbox-marked-circle</v-icon>
                  </v-btn>
                </template>
                <span>Move to next step (Planning)</span>
              </v-tooltip>
            </div>

            <v-tooltip bottom color="secondary">
              <template v-slot:activator="{ on }">
                <v-btn outlined color="accent" class="btn-save" @click="clickSave" v-on="on">
                  Save
                </v-btn>
              </template>
              <span>Save current inputs</span>
            </v-tooltip>
          </v-col>
          <v-col class="spacing-col" cols="2"></v-col>
        </v-row>
      </v-container>
    </div>
  </v-card>
</template>
<script>
import InitiationDetails from '@/components/workorders/taskManagerTabs/InitiationDetails'
import FileUpload from '@/components/files/FileUpload'
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'Initiation',
  components: {
    InitiationDetails,
    FileUpload
    },
      props: {
      initiationSaved: {
        type: Function,
        required: true
      }
    },
  methods: {
    ...mapActions({
      update: 'workOrderTask/updateTask'
    }),
    clickSave () {
      this.$refs.details.clickSave()
    },
    complete () {
      let updateStatus = this.task
      updateStatus.status = 'Planning'
      delete updateStatus.workOrder
      this.update(updateStatus)
    },
    reset () {
      let updateStatus = this.task
      updateStatus.status = 'Initiation'
      delete updateStatus.workOrder
      this.update(updateStatus)
    }
  },
  data () {
    return {
      tab: 'details'
    }
  },
  computed: {
    ...mapGetters({
      task: 'workOrderTask/selectedTask',
      images: 'image/imagesByTask',
      documents: 'document/documentsByTask',
      userRole: 'user/role'
    }),
    disabled () {
      return !this.task
    }
  }
}
</script>
<style scoped>
  .input-card {
    border: 1px solid #e0e0e0 !important;
    border-radius: 0;
  }
  .input-wrapper {
    min-height: 280px;
    padding: 0;
  }
  .tab-bar {
    border-bottom: 1px solid #e0e0e0 !important;
  }
  .btn-wrapper {
    padding: 0 12px 16px 0 !important;
    margin-bottom: 16px;
  }
  .btn-reset,
  .btn-save,
  .btn-complete {
    float: right;
  }
  .btn-complete {
    color: #fff;
    margin: 0 0 0 16px;
  }
  .btn-reset {
    margin-left: 16px;
  }
  @media only screen and (max-width: 959px) {
    .input-wrapper {
      padding: 0 16px;
    }
    .btn-wrapper {
      padding-right: 28px !important;
    }
    .spacing-col {
      display: none;
    }
  }
  @media only screen and (max-width: 550px) {
    .document-uploader-wrapper {
      padding-bottom: 20px;
    }
  }
  @media only screen and (max-width: 420px) {
    .input-card {
      border-left: none !important;
      border-right: none !important;
      border-radius: 0 !important;
    }
  }
</style>
